import React from 'react';
import styles from './setting.module.scss';
import { Subtitle, Title } from './title';
export const SettingHeaderComponent = ({ actions, settingName, settingSubTitle, actionHandler, learnMore, titleSize = 'medium', }) => (React.createElement(React.Fragment, null,
    React.createElement(Title, { settingTitle: settingName, actions: actions, actionHandler: actionHandler, titleSize: titleSize }),
    React.createElement("div", { className: styles.subText },
        React.createElement(Subtitle, { learnMore: learnMore, title: settingSubTitle }))));
export const SettingHeader = React.memo(SettingHeaderComponent);
//# sourceMappingURL=setting-header.js.map